<template>
  <div style="display: flex; flex-direction: column; gap: 20px">
    <EmailInput
      id="email"
      :field="$v.form.email"
      :state="validateState($v.form, 'email')"
      :server-errors="serverErrors['email']"
      @update="$v.form.email.$model = $event"
      @keyupEnter="login"
      label="Email"
      field-name="email"
    />

    <PasswordInput
      id="password"
      :field="$v.form.password"
      :state="validateState($v.form, 'password')"
      :server-errors="serverErrors['password']"
      @update="$v.form.password.$model = $event"
      @keyupEnter="login"
      label="Password"
      field-name="password"
    >
      <template #label-right>
        <router-link to="/forgot-password/send-email"
          >Forgot password?</router-link
        >
      </template>
    </PasswordInput>

    <SubmitButton
      :loading="loading"
      :text="button_text"
      @click.native="login"
    />

    <TextWithLines text="or continue with"></TextWithLines>

    <div style="display: flex; gap: 8px">
      <GoogleButton @click.native="googleLogin(form.email)"></GoogleButton>
      <MicrosoftButton
        @click.native="microsoftLogin(form.email)"
      ></MicrosoftButton>
    </div>

    <HorizontalDivider></HorizontalDivider>

    <div class="sign-up">
      Don't have an account?
      <a style="font-weight: 600" id="signIn" href="/">Sign up</a>
    </div>
  </div>
</template>

<script>
import EmailInput from "@/components/inputs/EmailInput";
import PasswordInput from "@/components/inputs/PasswordInput";
import login from "@/mixins/loopLogin/login";
import SubmitButton from "@/components/buttons/SubmitButton";
import MicrosoftButton from "../../buttons/MicrosoftButton.vue";
import GoogleButton from "../../buttons/GoogleButton.vue";
import TextWithLines from "../../ui/TextWithLines.vue";
import HorizontalDivider from "../../ui/HorizontalDivider.vue";
import oauthLogin from "../../../mixins/oauth/oauthLogin";

export default {
  name: "LoginForm",
  components: {
    HorizontalDivider,
    TextWithLines,
    GoogleButton,
    MicrosoftButton,
    SubmitButton,
    PasswordInput,
    EmailInput,
  },
  mixins: [login, oauthLogin],
  props: {
    button_text: { type: String, default: () => "Login" },
  },
};
</script>

<style scoped>
.sign-up {
  color: var(--theme-color-medium);
  font-size: 16px;
}
</style>
